import "./Order.css";

const OrderConfirmation = () => {
  return (
    <div className="order-page">
      <div className="order-container">
        {/* LEFT */}
        <div className="order-left">
          <div className="order-success">
            <div className="success-icon">✓</div>
            <h2>Thank you for your order!</h2>
            <p>Your order <strong>#NX-10245</strong> has been placed successfully.</p>
          </div>

          <div className="order-card">
            <h4>Order Details</h4>

            <div className="order-product">
              <img src="/images/product.jpg" alt="" />
              <div className="order-info">
                <strong>Address here</strong>
                <span>P/N: AP-N716 | SKU: 320689</span>
              </div>
              <div className="order-price">
                <span>Qty: 1</span>
                <strong>₹ 249.00</strong>
              </div>
            </div>

            <div className="order-meta">
              <div>
                <strong>Payment Method</strong>
                <span>Online Payment</span>
              </div>
              <div>
                <strong>Order Date</strong>
                <span>16 Jan 2026</span>
              </div>
            </div>
          </div>

          <button className="primary-btn">Continue Shopping</button>
        </div>

        {/* RIGHT */}
        <div className="order-right">
          <div className="order-card">
            <h4>Order Summary</h4>
            <div className="summary-row">
              <span>Subtotal</span>
              <span>₹ 249.00</span>
            </div>
            <div className="summary-row">
              <span>Shipping</span>
              <span className="success">Free</span>
            </div>
            <div className="summary-total">
              <span>Total</span>
              <span>₹ 249.00</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmation;
